import React, { useEffect, useMemo, useState } from 'react';
import { Button, FormGroup } from 'react-bootstrap';
import { DatePickerInput } from 'rc-datepicker';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { EMPTY_REKYV_LISTING_FILTERS } from 'services/utils/fileUpload/presignedZipUpload';

const FastagReKyvListingFilter = ({
  showFilter,
  filterToggle,
  applyFilter,
  filterFields = [],
  searchFields = {},
  appliedFilterValues = null,
}) => {
  const [filterFieldsData, setFilterFieldsData] = useState({ ...EMPTY_REKYV_LISTING_FILTERS });
  const [isFocusFrom, setIsFocusFrom] = useState(false);
  const [isFocusTo, setIsFocusTo] = useState(false);

  const statusOptions = useMemo(() => {
    const statusField = filterFields.find((field) => field.filter_name === 'request_status');
    return (
      statusField?.filter_data?.map((item) => ({
        id: item.value,
        name: item.text,
      })) || []
    );
  }, [filterFields]);

  const statusLabel =
    filterFields.find((field) => field.filter_name === 'request_status')?.filter_label ||
    'File Status';

  const createdDateLabel =
    filterFields.find((field) => field.filter_name === 'created_date')?.filter_label ||
    'Created Date';

  useEffect(() => {
    if (appliedFilterValues) {
      setFilterFieldsData({
        request_status: appliedFilterValues.request_status ?? '',
        created_date_from: appliedFilterValues.created_date_from ?? '',
        created_date_to: appliedFilterValues.created_date_to ?? '',
        request_id: appliedFilterValues.request_id ?? '',
        requestor_name: appliedFilterValues.requestor_name ?? '',
      });
      setIsFocusFrom(Boolean(appliedFilterValues.created_date_from));
      setIsFocusTo(Boolean(appliedFilterValues.created_date_to));
    } else {
      setFilterFieldsData({ ...EMPTY_REKYV_LISTING_FILTERS });
      setIsFocusFrom(false);
      setIsFocusTo(false);
    }
  }, [appliedFilterValues, showFilter]);

  return (
    <div className={showFilter ? 'show-filter' : ''}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>Filter List</h4>
            <Button onClick={filterToggle} className="close">
              <i className="close" />
            </Button>
          </div>
          <form
            className="filter-body scrollbar-styling"
            onSubmit={(event) => {
              event.preventDefault();
              applyFilter(filterFieldsData);
            }}
          >
          
            <ConstantInput
              label={searchFields.request_id || 'Request ID'}
              value={filterFieldsData.request_id}
              type="text"
              handleChange={(val) =>
                setFilterFieldsData({ ...filterFieldsData, request_id: val })
              }
            />

            <ConstantInput
              label={searchFields.requestor_name || 'Requestor Name'}
              value={filterFieldsData.requestor_name}
              type="text"
              handleChange={(val) =>
                setFilterFieldsData({ ...filterFieldsData, requestor_name: val })
              }
            />
            
            <DropDownInput
              label={statusLabel}
              data={statusOptions}
              getValueById={filterFieldsData.request_status || ''}
              controlledValue={filterFieldsData.request_status ? undefined : null}
              getIdValue={(val) => {
                setFilterFieldsData({
                  ...filterFieldsData,
                  request_status: val?.id || '',
                });
              }}
            />
            
            <h4 className="mb-2 mt-3">{createdDateLabel}</h4>
            <FormGroup className={`date custom_date_picker ${isFocusFrom ? 'active-date' : ''}`}>
              <DatePickerInput
                onChange={(_, dateString) => {
                  setFilterFieldsData({
                    ...filterFieldsData,
                    created_date_from: dateString,
                  });
                }}
                value={filterFieldsData.created_date_from}
                autoClose
                onShow={() => setIsFocusFrom(true)}
                onHide={() => {
                  if (!filterFieldsData.created_date_from) setIsFocusFrom(true);
                }}
                closeOnClickOutside
                showOnInputClick
                locale="en"
                className="my-custom-datepicker-component"
                displayFormat="DD-MM-YYYY"
                returnFormat="DD-MM-YYYY"
                maxDate={new Date()}
              />
              <label>{localization.fromDate}</label>
            </FormGroup>

            <FormGroup className={`date custom_date_picker ${isFocusTo ? 'active-date' : ''}`}>
              <DatePickerInput
                onChange={(_, dateString) => {
                  setFilterFieldsData({
                    ...filterFieldsData,
                    created_date_to: dateString,
                  });
                }}
                value={filterFieldsData.created_date_to}
                autoClose
                onShow={() => setIsFocusTo(true)}
                onHide={() => {
                  if (!filterFieldsData.created_date_to) setIsFocusTo(true);
                }}
                closeOnClickOutside
                showOnInputClick
                locale="en"
                className="my-custom-datepicker-component"
                displayFormat="DD-MM-YYYY"
                returnFormat="DD-MM-YYYY"
                maxDate={new Date()}
                disabled={!filterFieldsData.created_date_from}
              />
              <label>{localization.toDate}</label>
            </FormGroup>

            <div className="btn-wrapper">
              <button type="submit" className="btn btn-primary">
                {localization.applyFilter}
              </button>
              <br />
              <br />
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => applyFilter({ ...EMPTY_REKYV_LISTING_FILTERS })}
              >
                {localization.removeFilter}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default FastagReKyvListingFilter;
